import React from "react";
import { NavButton } from "../../components";
import "./NotFound.css"

export function NotFoundPage() {
  return (
    <>
      <div className="ContentContainer">
        <h1>Looks Like You're Lost</h1>
        <h2>Head back home and get back into the action</h2>
        <NavButton text="Home" route="/" />
      </div>
    </>
  );
}
